import React, { useState, useRef, useEffect } from "react";
import { useParams } from "react-router-dom";
import "../programs/Programs.css";
import "./PatientNotes.css";
import axios from "axios";
import moment from "moment";

const PatientNotes = (props) => {
  let { id } = useParams();
  const [noteText, setNoteText] = useState("");
  const [errorPopUp, setErrorPopUp] = useState("");
  const [succPopUp, setSuccPopUp] = useState(false);
  const [isNoteSending, setNoteSending] = useState(false);
  const popupRef = useRef(errorPopUp);

  const handleNoteChange = (event) => {
    setNoteText(event.target.value);
  };

  useEffect(() => {
    popupRef.current = errorPopUp;
    const timeout = setTimeout(() => {
      setErrorPopUp("");
    }, 5000);
    return () => {
      clearTimeout(timeout);
    };
  }, [errorPopUp]);

  const popupSuccRef = useRef(succPopUp);
  useEffect(() => {
    popupSuccRef.current = succPopUp;
    const timeout = setTimeout(() => {
      setSuccPopUp("");
    }, 5000);
    return () => {
      clearTimeout(timeout);
    };
  }, [succPopUp]);

  const saveNote = () => {
    if (noteText.trim().length > 0) {
      setNoteSending(true);
      props.saveNote();
      axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
      axios
        .post(window.ajaxLink + "cloud_therapist/save_patient_note", { patient_id: id, note: noteText })
        .then((res) => {
          if (res.data.responseData) {
            setNoteText("");
            setSuccPopUp("Note has been saved successfully.");
            setNoteSending(false);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      setErrorPopUp("Please fill in note text.");
      return;
    }
  };

  return (
    <div className=" twroles_dash_top">
      <div className="programs_dash_hold twroles_dash_no_marg notes_fix_height">
        {props.patientNotes && props.patientNotes.length > 0
          ? props.patientNotes.map((item, i) =>
              isNoteSending ? (
                <div className="loader_full_container">
                  <div className="p_load"></div>
                </div>
              ) : (
                !isNoteSending && (
                  <div key={i} className="single_notes_container">
                    <div className="notes_therapist">{item.therapist_name}</div>
                    <div className="notes_text">{item.note}</div>
                    <div className="notes_date">{moment(item.note_time).format("MM/DD/YYYY, hh:mm A")}</div>
                  </div>
                )
              )
            )
          : props.patientNotes.length === 0 &&
            isNoteSending && (
              <div className="loader_full_container">
                <div className="p_load"></div>
              </div>
            )}
        {props.patientNotes.length === 0 && !isNoteSending && (
          <div className="no_notes_message">There are currently no notes for this patient.</div>
        )}
      </div>
      <div className="add_note_form">
        <textarea
          onChange={handleNoteChange}
          maxLength={250}
          placeholder={"Enter note text"}
          className={!errorPopUp ? "note_input_form" : "note_input_form_err"}
          value={noteText}
        ></textarea>
        <div className="note_btn_form" onClick={() => saveNote()}>
          Add Note
        </div>
      </div>
      {errorPopUp && (
        <div className="prog_err_hold">
          <div className="prog_err_icon"></div>
          <div className="prog_err_text">{errorPopUp}</div>
        </div>
      )}
      {succPopUp && (
        <div className="prog_err_hold prog_pop_pat_correct">
          <div className="prog_pop_icon_correct prog_err_icon"></div>
          <div className="prog_err_text prog_pop_text_correct">{succPopUp}</div>
        </div>
      )}
    </div>
  );
};

export default PatientNotes;
